import type {
  SYSColumnDef,
  SYSTableDef,
} from "../../../../../../src/library/table/tableapi"

export type SYSTableSettings_ColumnFilter = {
  // we need a Differentiator here for TableSettings. Thats why we just include TableDefId
  TableDefId?: string
  // Key = Base row key from base TableDef row
  Key?: string
  /*Selected?: boolean*/
  Code?: string
  Free1?: string
  Count?: number
  OriginalSort?: number
}

let columns: { [key in keyof SYSTableSettings_ColumnFilter]: SYSColumnDef } = {
  // Selected: {
  //   sortable: true,
  //   ui: {
  //     labelTranslationKey: "SYSTableSettingsColFilterSelected",
  //     visibility: "Table",
  //   },
  // },
  Code: {
    sortable: true,
    type: "text",
    ui: {
      visibility: "Table",
      align: "left",
      labelTranslationKey: "SYSTableSettingsColFilterCode",
    },
  },
  Free1: {
    sortable: true,
    type: "text",
    ui: {
      visibility: "None",
      labelTranslationKey: "SYSTableSettingsColFilterAdditionalColumn",
    },
  },
  Count: {
    sortable: true,
    type: "int",
    ui: {
      labelTranslationKey: "SYSTableSettingsColFilterCount",
      visibility: "Table",
    },
  },
}

export let tblTableSettings_ColumnFilter: SYSTableDef = {
  id: "SYSTableSettings_ColumnFilter",
  feature: "SYSTableSettings",
  options: {
    filterSortSettings: {
      staticFilterKey: "TableDefId",
    },
    navType: "custom",
    initial_paging: { page: 0, pageSize: 200 },
    initial_sortCustom: {
      selected: "",
      sorts: {
        OriginalSort: {
          showInTitle: false,
          translationKey: "SYSTableSettingsOriginalSort",
        },
      },
    },
    initial_filter: {
      static: { TableDefId: "" },
    },
  },
  database: {
    dataIdField: "Code",
  },
  features: {
    showFooterButtons: false,
    autoCloseButtonIfInsideDialog: true,
    page: true,
    headerMenu: true,
    multiSelect: true,
  },
  columns,
}
